<template>
    <div class="result-section">
        <div class="result-block">
            <ul class="dealer-info">
                <li class="dealer-block">
                    <lender-rating-info
                        :lender-review-rating-details="lenderReviewRatingDetails"
                        :partner-name="offer.PartnerName"
                        :partner-type="offer.PartnerType"
                        :lender-id="offer.LenderId"
                    />
                    <ul
                        v-for="(badges, index) in badgesDetail"
                        v-show="badgesDetail && badgesDetail.length > 0"
                        :key="index"
                        class="grade">
                        <li>{{ badges }}</li>
                    </ul>
                </li>
                <li class="apr-block">
                    <small>APR as low as</small>
                    <span>{{ offer.Apr }}%</span>
                </li>
                <li class="apr-block">
                    <small>Monthly Payment</small>
                    <span>${{ paymentFilter(offer.calculatedMonthlyPayment) }}/mo</span>
                </li>
                <li class="more-details-block">
                    <button
                        class="btn btn-orange"
                        type="submit"
                        @click="navigate(offer.LenderId)">
                        {{ DestinationButtonText }}
                    </button>
                    <label
                        v-if="(IsHasOffer || Description)"
                        @click="IsLenderActive = !IsLenderActive">
                        <i :class="{'lt4-Minus': IsLenderActive, 'lt4-Plus' : !IsLenderActive}"></i> {{ !IsLenderActive ? "More" : "Less" }} Information
                    </label>
                </li>
            </ul>
            <loan-term-lender-info
                v-if="IsLenderActive && ((offer && offer !== undefined) || Description)"
                :lender-description="Description"
                :offer="getOfferConditions(offer.LenderId)"
            />
        </div>
    </div>
</template>

<script>
    import Accounting from 'accounting';
    import { find } from 'lodash-es';
    import BaseMixin from '~/mixin/base-mixin';
    import LenderRatingInfo from './lender-rating-info.vue';
    import LoanTermLenderInfo from './loan-term-lender-info.vue';
    import RateTableInfo from '~/mixin/rate-table-offer-tracking';

    export default {
        components: {
            LenderRatingInfo,
            LoanTermLenderInfo,
        },
        mixins: [BaseMixin, RateTableInfo],
        props: {
            offer: {
                default() {
                    return {};
                },
            },
            badgesDetail: {
                default() {
                    return [];
                },
            },
            isLenderActive: {
                default: false,
            },
            destinationButtonText: {
                default: 'See if you qualify',
            },
            destinationLinkOrId: {
                default: 'wp-auto&loan-type=refinance',
            },
            offerConditions: {
                default() {
                    return {};
                },
            },
            lenderOfferDetails: {
                default() {
                    return [];
                },
            },
            lenderReviewRatingDetails: {
                default() {
                    return [];
                },
            },
            fieldEdited: {
                default: 'no',
            },
        },
        data() {
            return {
                DestinationButtonText: this.destinationButtonText,
                DestinationLinkOrId: this.destinationLinkOrId,
                IsLenderActive: this.isLenderActive,
                IsHasOffer: false,
                FieldEdited: this.fieldEdited,
            };
        },
        computed: {
            Description() {
                let value = '';
                if (this.lenderOfferDetails) {
                    // eslint-disable-next-line eqeqeq
                    const lenderInfo = find(this.lenderOfferDetails, lender => lender.key == this.offer.LenderId);
                    if (lenderInfo && lenderInfo.value && lenderInfo.value.description) {
                        value = lenderInfo.value.description;
                    }
                }
                return value;
            },
        },
        watch: {
            Description() {
                this.IsHasOffer = this.Description && (this.offer && this.offer !== undefined);
            },
        },
        methods: {
            paymentFilter(figure) {
                return figure > 0 ? Accounting.formatNumber(figure) : 0;
            },
            navigate(LenderTrusteeUid) {
                this.DestinationLinkOrId = `${this.destinationLinkOrId}&userselectedlender=${LenderTrusteeUid}`;
                this.rateTableClickedInfo(this);
                this.redirect();
            },
            getOfferConditions(LenderId) {
                const offer = {};
                if (this.offerConditions) {
                    for (let i = 0; i < this.offerConditions.length; i++) {
                        if (this.offerConditions[i] !== undefined) {
                            // eslint-disable-next-line eqeqeq
                            if (this.offerConditions[i][0] && this.offerConditions[i][0].LenderId == LenderId) {
                                return this.offerConditions[1][0];
                            }
                        }
                    }
                }
                return offer;
            },
            updateToggleLink() {
                this.IsHasOffer = false;
            },
        },
    };
</script>
